import { render, staticRenderFns } from "./ApplicantProjectContracts.vue?vue&type=template&id=087c54a9&scoped=true&"
import script from "./ApplicantProjectContracts.vue?vue&type=script&lang=js&"
export * from "./ApplicantProjectContracts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087c54a9",
  null
  
)

export default component.exports